export interface NewContractIAImportProcess {
  contractID: number;
  fileIds: string[]; // array of uuids
  hasPassword: boolean;
  reWriteExistingData: boolean;
  password?: string;
  additionalPromptInformation?: string;
}

export interface ContractIAImportProcess {
  id: string; // uuid
  contractID: number;
  dateTimeSync?: Date | string;
  startTimestamp?: Date | string;
  endTimestamp?: Date | string;
  duration?: string;
  errorMessage?: string;
  errorStackTrace?: string;
  fileId?: string;
  durationSeconds?: number;
  isRunning?: boolean;
  statusName?: string;
  status: number; // ContractProcessStatusEnum

  // Feedback de la importación. Se registra UNA sola vez y es inmutable:
  // la API rechaza con 409 cualquier intento posterior.
  rating?: number | null; // ImportFeedbackRatingEnum (1..5)
  ratingName?: string | null;
  ratingLabel?: string | null;
  ratingMeaning?: string | null;
  feedbackComment?: string | null;
  feedbackBy?: string | null;
  feedbackAt?: Date | string | null;
  isRated?: boolean;
}

export enum ContractProcessStatusEnum {
  Pending = 1,
  Processing = 2,
  Synchronized = 3,
  Failed = 4,
  Completed = 5
}

// Escala de puntuación publicada por la API (GET contracts/import/feedback/scale).
// Los textos NO se hardcodean en el cliente: una corrección de wording tiene que
// llegar sin redeployar la app.
export interface ImportFeedbackRatingScaleItem {
  rating: number;
  ratingName?: string | null;
  ratingLabel?: string | null;
  ratingMeaning?: string | null;
}

export interface RateContractIAImportProcess {
  processId: string; // uuid
  rating: number; // 1..5
  feedbackComment?: string; // opcional, hasta 2000 caracteres
}

export const IA_IMPORT_FEEDBACK_COMMENT_MAX_LENGTH = 2000;

// La API responde 409 cuando el proceso ya tiene calificación, y devuelve la
// calificación vigente en el cuerpo. Se transporta junto al error para que la
// UI pueda explicar el rechazo y mostrar la puntuación sin volver a consultar.
export interface RateImportConflictError {
  ErrorCode: number;
  ErrorMessage: string;
  Errors: string[];
  alreadyRatedProcess?: ContractIAImportProcess;
}
